
// window.jsdom = true;

define('sites/socialpsychology.org/app',[
	"plugins/bootstrap/modal",
	"plugins/bootstrap/tooltip",
	"plugins/jquery/dateFormat",
	"plugins/jquery/cookie",
	"plugins/underscore/mixins", 
	"plugins/backbone/socketio",
	"plugins/backbone/bootstrap-modal",
	"plugins/backbone/modelBinder"
	], function() {
		
		require(["sites/socialpsychology.org/routes",
				"models/browserDetect",
				"text!views/errors/browser.html",
				"views/template/index"], function(all_routes, BrowserDetect, browserMessage, TemplateView) {
		 
			// Lets make sure the compiler doesn't use ajax.
			if(window.jsdom && window.getJSON)
				$.getJSON = window.getJSON;
		
			// Lets make sure both jQuerys have the same plugins.
			Backbone.$.fn.extend($.fn);
			$.fn.extend(Backbone.$.fn);
		
			// Lets setup the validation plugin.
			Backbone.Validation.configure({
			  labelFormatter: 'label'
			});

			/**
			*
			* Lets find what set of routes work with this domain
			*
			**/
			var routes,
				subdomain = document.location.host.replace("."+window.config.rootdomain, "");

			_.each(all_routes, function(value, key) { if(key == subdomain) routes = value;});

			// If we don't match any of the domains, lets assume its a custom profile username subdomain.
			if(!routes) routes = all_routes.profile;

			/**
			*
			* Now that we know what routes we have, lets make a Backbone Router
			*
			**/
			var route_config = _.object(_.keys(routes), _.keys(routes))
			var AppRouter = Backbone.Router.extend({routes: route_config});

			// Instantiate the router
			var app_router = new AppRouter;
			window.app_router = app_router;

			_.each(routes, function(obj, j) {
				app_router.on('route:'+j, function () {
				
					// If the page specifies it extend another, lets grab that data
					if(obj.extend) obj = _.extend({}, all_routes[obj.extend[0]][obj.extend[1]], obj);
					
					window.app_loaded = obj.app;
					var vars = _.union([subdomain, j, document.body], _.toArray(arguments));

					// If this is a production server and we are not generating the page with jsdom, lets use a digested javascript.
					if(!window.jsdom && window.config.production) {
						var paths = {};
						paths["sites/socialpsychology.org/page/"+obj.app] = "../js/app/"+obj.app+"-"+window.config.js_version;
						requirejs.config({
						    paths: paths
						});
					}
				
					// set the title per the configuration
					if(window.jsdom || !window.production) {
						if(obj.title) $("title").html(obj.title);
						if(obj.description) $("meta[name=description]").html(obj.description);
					}
				
					/**
					*
					* Lets check the browser support for this page and show browser warning if need be
					*
					*/
					var browserDetect = new BrowserDetect();
					if(!browserDetect.hasAtLeast((obj.browser ? obj.browser : ["msie 9", "safari 5", "firefox 21"]))) {
						var templateView = new TemplateView({el: document.body});
						templateView.$("#content").html(browserMessage);
						return;
					}

					// Lets pull the app
					require(["sites/socialpsychology.org/page/"+obj.app], function(init) { 
						console.debug("app.load", j);
						init.apply(this, vars); 
					});
				});

			});

			// Start Backbone history a necessary step for bookmarkable URL's. If theres no push state lets
			// just load the url without bookmarking.
			if(window.config.test) {
				window.config.test();
			} else {
				if(history.pushState) {
					Backbone.history.start({pushState: true});
				} else {
					Backbone.history.loadUrl(window.location.pathname);
				}	
			}


			/**
			*
			* Lets route all the relative links thru the Backbone Router
			*
			*/
			// $(document).on("click", "a[href^='/']", function(event) {
			// 	  
			// 	var href = $(event.currentTarget).attr('href');
			// 	  
			// 	if (window.router && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey && href.substring(0,2) != "//") {
			// 
			// 		event.preventDefault();
			// 
			// 		var url = href.replace(/^\//, '');
			// 	
			// 		app_router.navigate(url, {
			// 			trigger: true
			// 		});
			// 		
			// 		window.router(url);
			// 		
			// 		return false;
			// 	}
			// });
		
		});
});
